<template>
  <v-dialog
    v-model="isVisible"
    :fullscreen="isFullScreen"
    height="64"
    max-height="64"
    max-width="850"
    persistent
    scrollable
  >
    <v-card v-if="editItem">
      <v-toolbar
        flat
      >
        <v-avatar
          class="mr-3"
          color="blue"
        >
          <v-icon color="blue lighten-5">
            {{ editItem?.Id ? $t('Marketing.Sms.Dialog.EditCampaign.Toolbar.Icon') : $t('Marketing.Sms.Dialog.AddCampaign.Toolbar.Icon') }}
          </v-icon>
        </v-avatar>


        <v-toolbar-title
          class="pl-1"
        >
          <div class="body-3">
            {{ editItem?.Id ? $t('Marketing.Sms.Dialog.EditCampaign.Toolbar.Title') : $t('Marketing.Sms.Dialog.AddCampaign.Toolbar.Title') }}
          </div>
          <div class="text-caption">
            {{ editItem?.Id ? $t('Marketing.Sms.Dialog.EditCampaign.Toolbar.SubTitle') : $t('Marketing.Sms.Dialog.AddCampaign.Toolbar.SubTitle') }}
          </div>
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          class="ml-0"
          icon
          @click="onCancelButtonClick"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text class="pa-2 fill-height">
        <v-form
          ref="dataForm"
          v-model="dataFormValid"
          @submit.prevent
        >
          <v-container
            class="pa-1"
            fluid
          >
            <v-row
              class="px-2"
              dense
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editItem.Name"
                  :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.Name.Hint')"
                  :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.Name.Label')"
                  :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.Name.Icon')"
                  :rules="formFieldRules.Name"
                  filled
                  hide-details="auto"
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="editItem.Tag"
                  :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.Tag.Hint')"
                  :items="tagItems"
                  :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.Tag.Label')"
                  :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.Tag.Icon')"
                  :rules="formFieldRules.Tag"
                  chips
                  class=""
                  clearable
                  dense
                  filled
                  height="56"
                  hide-details="auto"
                  item-text="Name"
                  item-value="Id"
                  multiple
                  persistent-hint
                  required
                >
                  <template #selection="data">
                    <v-chip
                      :key="data.item.Id"
                      class="chip--select-multi"
                      color="indigo"
                      label
                      small
                      text-color="white"
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item.Name }}
                    </v-chip>
                  </template>

                  <template
                    v-if="userCanManage"
                    #append-outer
                  >
                    <v-btn
                      color="primary"
                      icon
                      @click="showAddTagDialog"
                    >
                      <v-icon>
                        mdi-plus-circle
                      </v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Sms.Dialog.EditCampaign.Section.Audience') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-select
                            v-model="editItem.GroupIncludes"
                            :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupIncludes.Hint')"
                            :items="groups"
                            :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupIncludes.Label')"
                            :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupIncludes.Icon')"
                            :rules="formFieldRules.GroupIncludes"
                            chips
                            class=""
                            clearable
                            dense
                            filled
                            height="56"
                            hide-details="auto"
                            item-text="Name"
                            item-value="Id"
                            multiple
                            persistent-hint
                            required
                          >
                            <template #selection="data">
                              <v-chip
                                :key="data.item.Id"
                                class="chip--select-multi"
                                color="green"
                                label
                                small
                                text-color="white"
                                @input="data.parent.selectItem(data.item)"
                              >
                                {{ data.item.Name }}
                              </v-chip>
                            </template>
                          </v-select>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-select
                            v-model="editItem.GroupExcludes"
                            :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupExcludes.Hint')"
                            :items="groups"
                            :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupExcludes.Label')"
                            :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.GroupExcludes.Icon')"
                            :rules="formFieldRules.GroupExcludes"
                            chips
                            class=""
                            clearable
                            dense
                            filled
                            height="56"
                            hide-details="auto"
                            item-text="Name"
                            item-value="Id"
                            multiple
                            persistent-hint
                            required
                          >
                            <template #selection="data">
                              <v-chip
                                :key="data.item.Id"
                                class="chip--select-multi"
                                color="red"
                                label
                                small
                                text-color="white"
                                @input="data.parent.selectItem(data.item)"
                              >
                                {{ data.item.Name }}
                              </v-chip>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Sms.Dialog.EditCampaign.Section.Sender') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editItem.SenderName"
                            :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.SenderName.Hint')"
                            :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.SenderName.Label')"
                            :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.SenderName.Icon')"
                            :rules="formFieldRules.SenderName"
                            disabled
                            filled
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Sms.Dialog.EditCampaign.Section.Message') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col cols="12">
                          <v-textarea
                            v-model="editItem.Body"
                            :hint="$t('Marketing.Sms.Dialog.EditCampaign.Field.Body.Hint')"
                            :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.Body.Label')"
                            :prepend-icon="$t('Marketing.Sms.Dialog.EditCampaign.Field.Body.Icon')"
                            :rules="formFieldRules.Body"
                            clearable
                            counter
                            filled
                            hide-details="auto"
                            rows="5"
                            @input="onlyGsmCharactersMask(editItem.Body)"
                          >
                            <template #counter>
                              <div class="v-counter ma-0 fill-width text-right">
                                <div>
                                  <span class="orange--text">{{ countSmsTextProp.messages }} {{ $t('Marketing.Sms.Dialog.EditCampaign.Field.Info.Sms') }}</span> /
                                  <span class="info--text">{{ countSmsTextProp.length }} {{ $tc('Marketing.Sms.Dialog.EditCampaign.Field.Info.Characters', countSmsTextProp.length) }}</span>
                                </div>

                                <div
                                  class="mt-3 info--text"
                                  style="font-size: 11px"
                                >
                                  <div>{{ countSmsTextProp.encoding.replaceAll('_', '-') }} {{ $t('Marketing.Sms.Dialog.EditCampaign.Field.Info.Encoding') }}</div>
                                  <div>
                                    {{ countSmsTextProp.characterPerMessage }} {{ $tc('Marketing.Sms.Dialog.EditCampaign.Field.Info.Characters', countSmsTextProp.characterPerMessage) }} /
                                    {{ $t('Marketing.Sms.Dialog.EditCampaign.Field.Info.Sms') }}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Sms.Dialog.EditCampaign.Section.Delivery') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col
                          class="mr-12"
                          cols="auto"
                        >
                          <v-radio-group
                            v-model="deliveryType"
                            class="mt-0"
                            hide-details
                          >
                            <v-radio
                              key="now"
                              :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.ScheduledAt.LabelNow')"
                              class="my-2"
                              value="now"
                            />

                            <v-radio
                              key="scheduled"
                              :label="$t('Marketing.Sms.Dialog.EditCampaign.Field.ScheduledAt.LabelScheduled')"
                              class="my-2"
                              value="scheduled"
                            />
                          </v-radio-group>
                        </v-col>

                        <v-col cols="auto">
                          <v-tooltip
                            color="info"
                            max-width="300"
                            top
                          >
                            <template #activator="{on}">
                              <div v-on="on">
                                <v-subheader class="pa-0">
                                  {{ $t('Marketing.Sms.Dialog.EditCampaign.Field.RespectQuietHours.Label') }}
                                  <v-icon
                                    class="float-end"
                                    color="info"
                                    small
                                    style="top:-10px"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </v-subheader>
                              </div>
                            </template>

                            <span>{{ $t('Marketing.Sms.Dialog.EditCampaign.Field.RespectQuietHours.Tooltip') }}</span>
                          </v-tooltip>

                          <v-switch
                            v-model="editItem.RespectQuietHours"
                            :label="editItem.RespectQuietHours ? $t('Common.Button.Yes') : $t('Common.Button.No')"
                            class="pa-0 ma-0"
                            color="green"
                            hide-details
                            inset
                          />
                        </v-col>

                        <v-col
                          class="text-end"
                          cols="auto"
                        >
                          <div class="d-inline-flex mx-2">
                            <div>
                              <v-subheader
                                class="pa-0 py-1 justify-end"
                                style="min-width: 85px;"
                              >
                                Use Unicode
                              </v-subheader>

                              <v-switch
                                v-model="editItem.UseUnicodeCharset"
                                :label="editItem.UseUnicodeCharset ? $t('Common.Button.Yes') : $t('Common.Button.No')"
                                class="pa-0 ma-0"
                                color="orange"
                                hide-details
                                inset
                                @change="onlyGsmCharactersMask(editItem.Body)"
                              />
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" />

                        <template v-if="deliveryType === 'scheduled'">
                          <v-col cols="auto">
                            <v-menu
                              v-model="scheduledAtDateVisible"
                              :close-on-content-click="false"
                              max-width="290px"
                              min-width="290px"
                              offset-y
                              transition="scale-transition"
                            >
                              <template #activator="{on}">
                                <v-text-field
                                  v-model="scheduledAt.DateFrm"
                                  :label="$t('Common.Date.Title')"
                                  :rules="formFieldRules.ScheduledAtDate"
                                  prepend-icon="event"
                                  readonly
                                  @blur="scheduledAt.Date = parseDate(scheduledAt.DateFrm)"
                                  v-on="on"
                                />
                              </template>

                              <v-date-picker
                                v-model="scheduledAt.Date"
                                :locale="$i18n.languages.find(lang => lang.locale === $i18n.locale).code || 'el-GR'"
                                first-day-of-week="1"
                                scrollable
                                @input="($event) => {
                                  scheduledAt.DateFrm = formatDate($event)
                                  scheduledAtDateVisible = false
                                }"
                              />
                            </v-menu>
                          </v-col>

                          <v-col cols="auto">
                            <v-menu
                              v-model="scheduledAtTimeVisible"
                              :close-on-content-click="false"
                              offset-y
                              transition="scale-transition"
                            >
                              <template #activator="{on}">
                                <v-text-field
                                  v-model="scheduledAt.Time"
                                  :label="$t('Common.Date.Time')"
                                  :rules="formFieldRules.ScheduledAtTime"
                                  prepend-icon="access_time"
                                  readonly
                                  v-on="on"
                                />
                              </template>

                              <v-time-picker
                                v-model="scheduledAt.Time"
                                :locale="$i18n.languages.find(lang => lang.locale === $i18n.locale).code || 'el-GR'"
                                first-day-of-week="1"
                                format="24hr"
                                scrollable
                                @input="() => {scheduledAtTimeVisible = false}"
                              />
                            </v-menu>
                          </v-col>
                        </template>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-2">
        <v-spacer />

        <v-btn
          class="light-blue--text text--darken-1"
          outlined
          @click="onCancelButtonClick"
        >
          {{ $t('Common.Button.Close').toLocaleUpperCase($i18n.locale) }}
        </v-btn>

        <v-btn
          :disabled="formIsSaving"
          :loading="formIsSaving"
          color="blue"
          dark
          depressed
          @click="onSaveButtonClick"
        >
          {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
        </v-btn>

        <v-btn
          :disabled="formIsSaving || !appNotifySmsActive"
          :loading="formIsSaving"
          color="green"
          dark
          depressed
          @click="onSendButtonClick"
        >
          {{ $t('Common.Button.Send').toLocaleUpperCase($i18n.locale) }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <tag-add-dialog :visible.sync="tagAddDialogVisible" />

    <confirm-dialog
      :html-content="$t('Marketing.Sms.Dialog.EditCampaign.ConfirmSend.Content')"
      :html-title="$t('Marketing.Sms.Dialog.EditCampaign.ConfirmSend.Title')"
      :visible.sync="sendConfirmDialogVisible"
      :width="560"
      no-button-class="v-btn--outline green--text"
      title-class="red white--text lighten-0"
      yes-button-class="red white--text"
      yes-button-event="on-confirm-delete"
      @on-confirm-delete="onSendConfirm"
    />
  </v-dialog>
</template>

<script>
import Auth from '@/mixins/auth'
import AppData from '@/mixins/appdata.js'
import DialogVisible from '@/mixins/dialogVisible'
import {clone, mergeDeep} from '@/lib/helper/helper.js'
import TagAddDialog from '@/components/marketing/tag/TagAddDialog.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import {convertToGsm, smsTextInfo} from '@/lib/sms/smsTextInfo.js'

export default {
  name      : 'SmsCampaignEditDialog',
  components: {ConfirmDialog, TagAddDialog},
  mixins    : [Auth, AppData, DialogVisible],
  props     : {
    template: {
      type   : Object,
      default: undefined
    },

    groups: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {
      tags                    : [],
      tagAddDialogVisible     : false,
      isFullScreen            : true,
      dataFormValid           : false,
      editItem                : null,
      deliveryType            : 'now',
      scheduledAtDateVisible  : false,
      scheduledAtTimeVisible  : false,
      sendConfirmDialogVisible: false,
      scheduledAt             : {
        Date   : '',
        DateFrm: '',
        Time   : ''
      },
      defaultDataObj: {
        Id               : null,
        Type             : 'sms',
        Name             : '',
        Title            : '',
        Draft            : true,
        RespectQuietHours: false,
        UseUnicodeCharset: false,
        Tag              : [],
        GroupIncludes    : [],
        GroupExcludes    : [],
        SenderName       : '',
        SenderEmail      : '',
        Subject          : '',
        Body             : '',
        BodyText         : '',
        Source           : '',
        ScheduledAt      : '',
        Image            : '',
        ImageExt         : '',
        ImageBase64      : ''
      },
      formIsSaving  : false,
      formFieldRules: {
        Name: [
          (v) => !!v || this.$t('Marketing.Sms.Dialog.EditCampaign.Field.Name.Error.Required'),
          (v) => v && v.length >= 2 && v.length <= 255 || this.$t('Marketing.Sms.Dialog.EditCampaign.Field.Name.Error.Between')
        ],
        Body: [
          (v) => !!v || this.$t('Marketing.Sms.Dialog.EditCampaign.Field.Body.Error.Required')
        ],
        ScheduledAtDate: [
          (v) => !!v && this.deliveryType === 'scheduled' || this.$t('Marketing.Sms.Dialog.EditCampaign.Field.ScheduledAt.Error.RequiredDate')
        ],
        ScheduledAtTime: [
          (v) => !!v && this.deliveryType === 'scheduled' || this.$t('Marketing.Sms.Dialog.EditCampaign.Field.ScheduledAt.Error.RequiredTime')
        ]
      }
    }
  },
  computed: {
    countSmsTextProp() {
      return this.countSmsText(this.editItem?.Body || '')
    },

    tagItems() {
      return this.tags.filter(tag => !tag.IsDeleted)
    }
  },
  watch: {
    deliveryType(newVal) {
      if (newVal === 'now') {
        this.editItem.ScheduledAt = ''
      }
    },

    scheduledAt: {
      deep: true,
      handler(newVal) {
        if (newVal.Date && newVal.Time) {
          this.editItem.ScheduledAt = `${newVal.Date} ${newVal.Time}:00`
        }
      }
    },

    isVisible(newVal) {
      if (newVal) {
        this.initDialog()
      } else {
        this.destroyDialog()
      }
    }
  },
  created() {
    this.initDialog()
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.destroyDialog()
  },
  methods: {
    initDialog() {
      this.tags = []
      this.editItem = clone(mergeDeep(this.defaultDataObj, this.template || {}))
      this.onlyGsmCharactersMask(this.editItem.Body)

      if (this.editItem.ScheduledAt) {
        const [d, t] = this.editItem.ScheduledAt.split(' ')
        this.scheduledAt = {
          Date   : this.parseDate(d, '/'),
          DateFrm: this.formatDate(this.parseDate(d, '/')),
          Time   : t.substring(0, t.length - 3)
        }

        this.deliveryType = 'scheduled'
      } else {
        this.scheduledAt = {
          Date   : '',
          DateFrm: '',
          Time   : ''
        }
        this.deliveryType = 'now'
      }
      this.initEvents()
      this.getTags()
    },
    destroyDialog() {
      this.tags = []
      this.editItem = null
      this.destroyEvents()
    },
    initEvents() {
      this.destroyEvents()
      this.$bus.$on(window.SocketCommand.Marketing.Sms.Save, this.onSaveResult)
      this.$bus.$on(window.SocketCommand.Marketing.Sms.Send, this.onSendResult)
      this.$bus.$on(window.SocketCommand.Marketing.Tag.Save, this.getTags)
      this.$bus.$on(window.SocketCommand.Marketing.Tag.Combo, this.onTagsResult)
    },
    destroyEvents() {
      this.$bus.$off(window.SocketCommand.Marketing.Sms.Save, this.onSaveResult)
      this.$bus.$off(window.SocketCommand.Marketing.Sms.Send, this.onSendResult)
      this.$bus.$off(window.SocketCommand.Marketing.Tag.Save, this.getTags)
      this.$bus.$off(window.SocketCommand.Marketing.Tag.Combo, this.onTagsResult)
    },

    getTags() {
      window.callAS(window.SocketCommand.Marketing.Tag.Combo)
    },

    onSaveButtonClick() {
      if (!this.$refs.dataForm.validate()) return

      this.formIsSaving = true
      const payload = clone(this.editItem)
      payload.Draft = true

      window.callAS(window.SocketCommand.Marketing.Sms.Save, payload)
    },

    onSaveResult(data) {
      this.formIsSaving = false

      if (data && data.status === 'success') {
        if (data?.Id) this.editItem.Id = data.Id
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Marketing.Sms.Dialog.EditCampaign.Message.Save.Success'),
          type: 'success',
          icon: 'info'
        })
      } else {
        this.showGenericError()
      }
    },

    onSendButtonClick() {
      if (!this.appNotifySmsActive || !this.$refs.dataForm.validate()) return
      this.sendConfirmDialogVisible = true
    },

    onSendConfirm() {
      this.formIsSaving = true
      const payload = clone(this.editItem)
      payload.Draft = false

      window.callAS(window.SocketCommand.Marketing.Sms.Save, payload, window.SocketCommand.Marketing.Sms.Send)
    },

    onSendResult(data) {
      this.formIsSaving = false

      if (data && data.status === 'success') {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Marketing.Sms.Dialog.EditCampaign.Message.Send.Success'),
          type: 'success',
          icon: 'info'
        })
        this.onCancelButtonClick()
      } else {
        this.showGenericError()
      }
    },

    onTagsResult: function (data) {
      if (Array.isArray(data)) {
        this.tags = data || []

        this.editItem.Tag = this.editItem.Tag.filter(tagId => data.some(t => tagId === t.Id && !t.IsDeleted))
      }
    },

    showAddTagDialog() {
      this.tagAddDialogVisible = true
    },

    showGenericError() {
      this.$bus.$emit('app-show-notification', {
        body: this.$t('Common.Error.Generic'),
        type: 'error',
        icon: 'warning'
      })
    },

    formatDate(date, separator = '-') {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split(separator)
      return `${day}-${month}-${year}`
    },

    parseDate(date, separator = '-') {
      if (!date) {
        return null
      }

      const [day, month, year] = date.split(separator)
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },

    countSmsText(text) {
      return smsTextInfo(text || '')
    },

    convertSmsTextToGsm(text) {
      return convertToGsm(text || '')
    },

    onlyGsmCharactersMask(text) {
      if (this.editItem?.useUnicodeCharset) return

      const sms = this.convertSmsTextToGsm(text || '')
      this.editItem.Body = sms //.toUpperCase()
    },

    onCancelButtonClick() {
      this.closeDialog()
    }
  }
}
</script>
